import type { AbstractOption } from '~shared/types/abstract-option';

const options = [
  {
    value: 'FAMILY',
    label: 'Family member',
  },
  {
    value: 'OTHER',
    label: 'Other',
  },
] as const;

export type OFWRelationshipValue = (typeof options)[number]['value'];
export const ofwRelationshipOptions =
  options as unknown as AbstractOption<OFWRelationshipValue>[];
